import { TablePageLayout, DataTableExRef } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { UsersTable } from 'components/UsersTable';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function Users() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout
        title="Gebruikers"
        actionContent={
          <Button
            sx={{ ml: 5 }}
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              tableRef.current?.openFormDialog();
            }}
          >
            Gebruiker toevoegen
          </Button>
        }
      >
        <UsersTable
          id="users-table"
          ref={tableRef}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam of e-mail',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [
                { name: { _ilike: `%${str}%` } },
                { email: { _ilike: `%${str}%` } },
              ]),
            }),
          }}
          formDialogProps={{
            formProps: {
              defaultValues: {},
            },
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
